import { theme } from '@theme';
import styled from 'styled-components';

export const WrapperPrivateIncentiveContainer = styled.div`
  .private-inc-container {
    overflow: hidden;
  }
`;

export const WrapperPrivateIncentiveLookupSearch = styled.div`
  .header-text{
    text-align:center;
  }
  .search-header{
    font-size: ${theme.typography.fontSize28}px;
    font-weight: ${theme.typography.fontWeights.semibold};
    line-height: 28px;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .form-group{
    padding-top:2px;
    padding-bottom:2px;
    margin-bottom: 15px;
  }
  .error{
    color: #C9112C;
    border: 1px solid #c64b5c;
    background-color: #f4dadf;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    text-align: left;
    margin-bottom: 10px;
    padding: 20px;
    font-size: ${theme.typography.h5}px;
    font-weight: ${theme.typography.fontWeights.semibold};
    line-height: 137%;
    }
    .am-icon-warning{
      color: #C9112C !important;
    }
  .error-text{
      padding-left:20px;
    }

  .error-icon{
    color: #C9112C !important;
    padding-right:15px;
    font-size: 120%;
}
  }
  .btn-disabled{
    width:100%;
    height:34px;
    color:#8f8c8c;
    background-color: rgb(239, 239, 239);
    border: 1px solid lightgray;
    border-radius: 4px;
  }
  .btn{
    width:100%;
    background-color: #7529A5;
    height:34px;
    color:white;
  }
  .control-text{
    text-align:left;
    padding-left:5px;
    display: flex ;
    justify-content: left;
    align-items: center;
    width: 250px;
  }
  .search-content{
    border: 2px solid #E7E9EB;
    border-radius:3px;
    padding:15px;
    background:white;
    max-width:350px;
    margin:auto;
    margin-top:30px;
    margin-bottom:100px;
  }
  .error-message{
    display: flex ;
  }
  .addresses-options{
    border: 1px solid ${theme.palette.lightGrey};
    border-radius: 4px;
    color: ${theme.palette.wetAsphalt};
    background: ${theme.palette.white};
    overflow-y: scroll;
    max-height: 144px;
    z-index: 1001;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    list-style: none;
    margin-bottom: 0px;
    padding-left: 0px;
    li:last-child { border-bottom: none; }
  }
  .address-option{
    display: flex;
    vertical-align: middle;
    padding: 6px 12px;
    border-bottom: 1px solid ${theme.palette.lightGrey};

    &:hover {
      cursor: pointer;
      background: ${theme.palette.lightPurpleTwo};
    }
  }
  .text-wrapper{
    float: left;
    padding-left: 5px;
    padding-bottom: 5px;
  }
  .edit-button{
    float: right;
    cursor: pointer;
  }
`;

export const WrapperPrivateIncentiveLookupSearchResult = styled.div`
  .header-text-result {
    padding-top: 25px;
    font-size: ${theme.typography.fontSize28}px;
    font-weight: ${theme.typography.fontWeights.semibold};
    line-height: 28px;
    text-align: center;
    padding-right: 0px;
  }
  .header-row {
    display: flex;
  }
  .back-btn {
    background-color: #dedddc;
    height: 30px;
    width: 75px;
    color: black;
    justify-content: left;
    border: none;
    margin-top: 25px;
    margin-bottom: 10px;
    border-radius: 3px;
  }
  .incentive-card {
    display: flex;
    padding: 15px;
    margin: 0 auto;
    justify-content: center;
    align-items: top;
    flex-wrap: wrap;
    margin-left: 8.3%;
  }
`;
